import * as React from 'react';
import { Box, Container } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import CircularProgress from '@material-ui/core/CircularProgress';
import { AppPricePlanDetailsType, usePublicAppListingsQuery } from '../../../types/generated';
import { SearchBar } from '../../../components/SearchBar/SearchBar';
import { useStyles } from './css';
import { AppCard } from '../../../components/AppCard/AppCard';
import { HeroUnit } from '../../../components/HeroUnit/HeroUnit';
import { ActionContainer } from '../../../components/ActionContainer/ActionContainer';
import { useNavigate } from 'react-router-dom';

export function AppStoreHome() {
    const classes = useStyles();
    const navigate = useNavigate();

    const { loading: appsLoading, data: appsData } = usePublicAppListingsQuery({
        variables: {
            filter: {
                searchTerm: '',
            },
            first: 50,
        },
    });

    return (
        <React.Fragment>
            <HeroUnit
                title={
                    <>
                        Connecting you to the tools
                        <br />
                        that will make your business grow
                    </>
                }
                subTitle={'Powerful apps and integrations to help you run your business.'}
            >
                <Box textAlign="center">
                    <SearchBar
                        value={''}
                        placeholder={'Find the right app for you'}
                        onSearch={value => {
                            if (value.length > 0) {
                                navigate('/apps?q=' + value);
                            }
                        }}
                    />
                </Box>
            </HeroUnit>
            <div className={classes.paperBackground}>
                <Container maxWidth={'lg'}>
                    <Typography variant="h6" component="h5">
                        Latest apps
                    </Typography>
                </Container>
                <Container className={classes.cardGrid} maxWidth="lg">
                    {appsLoading ? (
                        <CircularProgress />
                    ) : (
                        <Grid container spacing={4}>
                            {appsData && appsData?.publicAppListings?.totalCount !== 0 ? (
                                appsData?.publicAppListings.edges.map(({ node: appListing }) => (
                                    <Grid item key={appListing.id} xs={12} sm={6} md={4} lg={3}>
                                        <AppCard
                                            id={appListing.id}
                                            title={appListing.name}
                                            tagLine={appListing.tagLine}
                                            imageUrl={appListing.icon.sourceUrl}
                                            priceType={appListing.chargeType}
                                            pricePlans={
                                                appListing.pricePlans as AppPricePlanDetailsType[]
                                            }
                                            freeTrialDays={appListing.freeTrialDays}
                                            oneTimeChargeAmount={appListing.oneTimeChargeAmount}
                                        />
                                    </Grid>
                                ))
                            ) : (
                                <Container>
                                    <Box
                                        p={4}
                                        py={6}
                                        display={'flex'}
                                        flexDirection={'column'}
                                        justifyContent={'center'}
                                    >
                                        <Box
                                            mb={2}
                                            fontWeight={500}
                                            fontSize={'28px'}
                                            color={'secondary.main'}
                                        >
                                            Nothing here
                                        </Box>
                                        <Box
                                            fontWeight={300}
                                            fontSize={'20px'}
                                            color={'secondary.main'}
                                        >
                                            No apps found for current condition
                                        </Box>
                                    </Box>
                                </Container>
                            )}
                        </Grid>
                    )}
                </Container>
            </div>

            <ActionContainer
                title={"Can't find what you need?"}
                message={
                    <>
                        Build your own apps in a matter of hours - whether just for <br />
                        your own team or for others to use too.
                    </>
                }
                button={{
                    linkTo: '/developer',
                    text: 'Explore the API',
                }}
            />
        </React.Fragment>
    );
}
